{
  "form": {
    "title": "Datos de la conexión",
    "description": "Fermin solo lee datos de tu sistema, con una clave de solo lectura.",
    "systemName": "Nombre del sistema",
    "systemNameHelp": "Cómo lo llaman en tu empresa, por ejemplo «RR. HH. central».",
    "baseUrl": "URL base",
    "baseUrlHelp": "Sin /v1; debe empezar con https://",
    "authMethod": "Método de autenticación",
    "authMethods": {
      "API_KEY": "API key en cabecera",
      "BEARER": "Bearer"
    },
    "authHeaderName": "Nombre de la cabecera",
    "authHeaderNameHelp": "Por defecto X-API-Key.",
    "secret": "Clave",
    "secretHelp": "Se guarda cifrada. Después solo verás sus últimos 4 caracteres.",
    "secretSaved": "Clave guardada ••••{last4}",
    "changeSecret": "Cambiar clave",
    "keepSecret": "Mantener la clave guardada",
    "newSecretHelp": "Si la dejas vacía, se mantiene la clave guardada.",
    "advanced": "Avanzado",
    "pageSize": "Registros por página",
    "pageSizeHelp": "Entre 1 y 500. Por defecto 200.",
    "datedShiftDaysAhead": "Días de turnos por fecha",
    "datedShiftDaysAheadHelp": "Cuántos días hacia adelante se leen los turnos por fecha (7 a 120).",
    "manualTitle": "Recursos que ofrece tu sistema",
    "manualDescription": "Tu sistema no informa qué datos ofrece. Márcalos, guarda y vuelve a probar la conexión.",
    "capabilities": {
      "sites": "Sedes",
      "workers": "Trabajadores",
      "WEEKLY_TEMPLATE": "Horarios con plantilla semanal",
      "DATED_SHIFT": "Turnos por fecha",
      "absences": "Ausencias",
      "holidays": "Feriados",
      "incremental": "Envía solo lo que cambió desde la última lectura"
    },
    "errors": {
      "system_name": "Ingresa un nombre de hasta 80 caracteres.",
      "base_url": "La URL debe empezar con https:// y no puede apuntar a una red interna.",
      "auth_header_name": "Usa solo letras, números y guiones (máx. 64).",
      "secret": "La clave debe tener entre 8 y 512 caracteres visibles, sin espacios.",
      "secretRequired": "Ingresa la clave del sistema externo.",
      "page_size": "Ingresa un número entre 1 y 500.",
      "dated_shift_days_ahead": "Ingresa un número entre 7 y 120.",
      "manual_capabilities": "Revisa los recursos marcados."
    }
  },
  "status": {
    "title": "Estado de la conexión",
    "empty": "Guarda la conexión para poder probarla.",
    "verified": "Verificada",
    "unverified": "Sin verificar",
    "disabled": "Desactivada",
    "company": "{name} · RUC {taxId}",
    "companyNoTax": "{name}",
    "contractVersion": "Versión del contrato: {version}",
    "capabilitiesTitle": "Lo que ofrece tu sistema",
    "capabilitiesManual": "Marcado a mano",
    "offered": "Sí",
    "notOffered": "No",
    "testedAt": "Probada el {date}",
    "neverTested": "Aún no se ha probado.",
    "lastFailure": "Última prueba: {failure}"
  },
  "test": {
    "button": "Probar conexión",
    "testing": "Probando…",
    "ok": "La conexión funciona.",
    "okWithCompany": "La conexión funciona con {company}.",
    "failed": "La conexión falló: {failure}",
    "requestId": "Id de la petición: {requestId}",
    "warningsTitle": "Para revisar",
    "goToSync": "Ir a Sincronizar"
  },
  "actions": {
    "save": "Guardar",
    "saved": "Conexión guardada",
    "createdHint": "Ahora pulsa «Probar conexión».",
    "saveFailed": "No se pudo guardar la conexión",
    "disable": "Desactivar",
    "enable": "Activar",
    "disableTitle": "¿Desactivar la integración?",
    "disableDescription": "No se podrá sincronizar hasta que la actives de nuevo. Lo ya integrado no cambia.",
    "enableTitle": "¿Activar la integración?",
    "enableDescription": "Se podrá volver a sincronizar con {system}.",
    "disabledToast": "Integración desactivada",
    "enabledToast": "Integración activada",
    "statusFailed": "No se pudo cambiar el estado"
  }
}
